import { useTranslation } from "react-i18next";
import { FeedbackFloatingButton } from "../../feedback/FeedbackFloatingButton";
import {
  ControlHeading,
  ControlStack,
  ControlSection,
  ControlRow,
} from "./DataControlParts";

export function FeedbackPanel() {
  const { t } = useTranslation("common");
  return (
    <ControlStack gap={24}>
      <ControlHeading
        title={t("feedback.floatingLabel")}
        description={t("settings.feedbackDescription")}
      />
      <ControlSection title={t("settings.groups.help")}>
        <FeedbackFloatingButton
          renderTrigger={(open) => (
            <ControlRow
              title={t("feedback.title")}
              icon="contact"
              onPress={open}
            />
          )}
        />
      </ControlSection>
    </ControlStack>
  );
}
